export var ModalButtonDefaultText;
(function (ModalButtonDefaultText) {
    ModalButtonDefaultText["OK"] = "Continue";
    ModalButtonDefaultText["CANCEL"] = "Cancel";
})(ModalButtonDefaultText || (ModalButtonDefaultText = {}));
export var ModalButtonDefaultProps = {
    size: 'large',
};
export var ModalHookClassName;
(function (ModalHookClassName) {
    ModalHookClassName["GENERAL"] = "i18n-ecom-alliance-modal-hook";
    ModalHookClassName["CONFIRM"] = "i18n-ecom-alliance-modal-hook-confirm";
    ModalHookClassName["INFO"] = "i18n-ecom-alliance-modal-hook-info";
    ModalHookClassName["SUCCESS"] = "i18n-ecom-alliance-modal-hook-success";
    ModalHookClassName["WARNING"] = "i18n-ecom-alliance-modal-hook-warning";
    ModalHookClassName["ERROR"] = "i18n-ecom-alliance-modal-hook-error";
})(ModalHookClassName || (ModalHookClassName = {}));
//# sourceMappingURL=types.js.map